import { DOM_IDS } from '../utils/constants';
import { redirectToUrl } from '../utils/url';
import unsubscribeSurveyListeners from './unsubscribeSurvey';
function returnToManagePreferences() {
  const managePreferencesButton = document.getElementById(DOM_IDS.managePreferencesButton);
  if (managePreferencesButton) {
    managePreferencesButton.addEventListener('click', function () {
      let pathSegments = window.location.pathname.split('/');
      pathSegments.pop();
      const newPath = pathSegments.join('/');
      const managePreferencesUrl = `${newPath}/page${window.location.search}`;
      redirectToUrl(managePreferencesUrl);
    });
  }
}
export default function addConfirmationListeners() {
  returnToManagePreferences();
  unsubscribeSurveyListeners();
}